import {
  ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { initializeApp, provideFirebaseApp, getApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { initializeFirestore, provideFirestore } from '@angular/fire/firestore';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { getRemoteConfig, provideRemoteConfig } from '@angular/fire/remote-config';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { mockInterceptor } from './core/interceptors/mock.interceptor';
import { PlansDataSource } from './core/data/plans/plans.datasource';
import { FirebasePlansDataSource } from './core/data/plans/firebase-plans.datasource';
import { ProfileDataSource } from './core/data/profile/profile.datasource';
import { FirebaseProfileDatasource } from './core/data/profile/firebase-profile.datasource';
import { GlobalErrorHandler } from './core/global-error-handler';
import { provideCardnet } from './core/cardnet';
import { ProvincesDataSource } from './core/data/provinces/provinces.datasource';
import { FirebaseProvincesDataSource } from './core/data/provinces/firebase-provinces.datasource';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideFirestore(() =>
      initializeFirestore(getApp(), {
        // Some adblockers/proxies block the streaming channel; this falls back to long polling.
        experimentalAutoDetectLongPolling: true,
      })
    ),
    provideFunctions(() => getFunctions()),
    provideRemoteConfig(() => getRemoteConfig()),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      })
    ),
    provideHttpClient(
      withInterceptors(environment.mock ? [mockInterceptor] : [])
    ),
    {
      provide: PlansDataSource,
      useClass: FirebasePlansDataSource,
    },
    {
      provide: ProvincesDataSource,
      useClass: FirebaseProvincesDataSource,
    },
    {
      provide: ProfileDataSource,
      useClass: FirebaseProfileDatasource,
    },
    provideBrowserGlobalErrorListeners(),
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    provideCardnet(environment.cardnet),
  ],
};
